import { useSelector } from "react-redux";

import { useInviteActions } from "store/InvitesSlice";
import { inviteAttributes, buildGuestAttributes, rsvpAttributes } from "utils/inviteUtils";

import useLastEcard from "./useLastEcard";

const useInvites = () => {
  const { setLastEcard } = useLastEcard();
  const {
    createInvite,
    loadInvite,
    loadInvites,
    loadMoreInvites,
    updateInvite,
    createGuest,
    updateGuest: _updateGuest,
    deleteGuest,
    loadGuestInvite,
    deleteInvite,
  } = useInviteActions();

  const { invite, invites, meta } = useSelector((state) => state.InvitesSlice);

  const saveInvite = ({ makeThumb, shareThumb, roles, templateId, templateGroupId, themeId }) => {
    const attrs = inviteAttributes({ makeThumb, shareThumb, roles, templateId, templateGroupId, themeId });

    return createInvite(attrs).then((inv) => {
      setLastEcard(inv);
      return inv;
    });
  };

  const saveGuest = ({ name, email }) => {
    const body = buildGuestAttributes({ name, email });
    return createGuest(invite, body);
  };

  const updateGuest = (guestId, { name, email }) => {
    const body = buildGuestAttributes({ name, email }, guestId);
    return _updateGuest(invite, guestId, body);
  };

  const updateGuestAsGuest = (guestId, { rsvp, additionalGuests = null }) => {
    const body = rsvpAttributes(guestId, { rsvp, additionalGuests });
    return _updateGuest(invite, guestId, body, "guest");
  };

  const removeGuest = (guestId) => {
    return deleteGuest(invite, guestId);
  };

  return {
    invite,
    invites,
    saveInvite,
    deleteInvite,
    updateInvite,
    loadInvite,
    loadInvites,
    loadMoreInvites,
    saveGuest,
    updateGuest,
    updateGuestAsGuest,
    removeGuest,
    loadGuestInvite,
    meta,
  };
};

export default useInvites;
